<template>
  <div>
    <div
      class="card bg-secondary shadow-sm border-0"
      style="border-radius: 50px; max-width: 600px; margin: 0 auto"
    >
      <div
        class="px-lg-5 py-lg-5 bg-white rounded-3xl"
        style="
          font-size: 2rem;
          position: relative;
          height: 390px;
          max-width: 600px;
          width: 100%;
          margin: 0 auto;
        "
      >
        <div class="logo" />
        <form @submit.prevent="login_form">
          <div class="form-group mb-3">
            <div class="input-group input-group-alternative">
              <input
                class="form-control"
                placeholder="Email"
                v-model="user.email"
                type="email"
              />
            </div>
          </div>
          <div class="form-group">
            <div class="input-group input-group-alternative">
              <input
                class="form-control"
                style="display: flex; align-items: center"
                placeholder="Password"
                v-model="user.password"
                :type="pass"
              />
            </div>
          </div>
          <p
            @click="ResetPass"
            style="
              color: #446daf;
              font-size: 13px;
              text-align: right;
              cursor: pointer;
              width: fit-content;
              float: right;
            "
          >
            ¿Olvidaste tu contraseña?
          </p>

          <div class="text-center">
            <span v-if="!loginButton">
              <button type="submit" class="btn-login my-4">Entrar</button>
            </span>
            <span v-else>
              <button class="my-4 btn-login" disabled>
                <div class="row">
                  <half-circle-spinner
                    class="mx-auto mt-2"
                    :animation-duration="600"
                    :size="17"
                    color="#ffffff"
                  />&nbsp;
                </div>
              </button>
            </span>
          </div>

          <p style="text-align: center; font-size: 13px">
            ¿No tienes cuenta?
            <span style="color: #446daf; cursor: pointer" @click="route"
              >Regístrate</span
            >
              ¿Olvidaste tu contraseña?
            </p>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import toastr from "toastr";
import axios from "axios";
import { HalfCircleSpinner } from "epic-spinners";

export default {
  name: "loginView",
  components: {
    HalfCircleSpinner,
  },
  data() {
    return {
      user: {
        email: null,
        password: null,
      },
      loginButton: false,
      isLoggedIn: false,
      companies: "",
      proyect_id: "2",
      show: false,
      pass: "password",
    };
  },
  methods: {
    route() {
      this.$router.push({ name: "Home" });
    },
    ResetPass() {
      this.$router.push({ name: "ResetPass" });
    },
    login_form() {
      if (!this.validateForm()) return;
      var url = "/api/v1/login";
      this.loginButton = true;
      axios
        .post(url, {
          email: this.user.email,
          password: this.user.password,
        })
        .then((response) => {
          if (response.data.role === 2) {
            this.$store.state.auth.token = response.data.access_token;
            window.localStorage.setItem("a_t", response.data.access_token);
            window.localStorage.setItem(
              "user",
              JSON.stringify(response.data.user)
            );
            this.$store.dispatch("auth/setStatusLogin", true);
            window.localStorage.setItem("isLogIn", response.data.isLogIn);
            this.$router.push({ name: "MyCourses" });
            this.$store.dispatch("shopingCart/upNoLogedCart");
          } else {
            this.loginButton = false;
            toastr.error("Su usuario no tiene permisos necesarios!");
          }
        })
        .catch(() => {
          this.loginButton = false;
          toastr.error("usuario o contraseña incorrectos!");
        });
    },
    validateForm () {
      return true;
    },
  },
};
</script>

<style scoped>
.go-back {
  position: relative;
  color: #fff;
  cursor: pointer;
  margin: 0 auto;
  margin-bottom: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 0px 5px 6px #00000029;
}

.go-back i {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

button {
  outline: none !important;
}

.input-group {
  border-radius: 0 !important;
}

.logo {
  width: 114px;
  height: 38px;
  background-size: contain;
  background-image: url(/image/brand/logo.png);
  margin: 0 auto;
  margin-bottom: 40px;
}

.btn-login {
  background: transparent linear-gradient(180deg, #f1946d 0%, #de337a 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 50px;
  opacity: 1;
  color: #ffffff;
  font-size: 23px;
  width: 80%;
  height: 52px;
  width: 284px;
  max-width: 100%;
  margin: 0 auto;
  margin-bottom: 10px !important;
}

.input-group-alternative {
  box-shadow: none !important;
  border: 0.5px solid #a7a7a7;
}

.input-group-prepend {
  margin-right: 0 !important;
}
</style>
